import config from '@iotv/config';
const { dynamoDB } = config.aws;
/*
 *   The metric dimension (key-value pairs) should be specificied when calling GetMetricWidgetImage api.
 *   The common metric dimension is hardcoded here, including general Lambda funcitons and SQS queues across different ventures.
 */
export const instanceDimensionsMap = {
    Lambda: {
        FunctionName: [
            'CalculatedState',
            'NetworkData-Stack-Processor',
            'FanOut-Stack-LambdaFanOut',
            'device-control-deviceState',
            'device-control-controller',
            'DynamoDB-DLC',
            'dead-letter-receiver',
            'DataLifecycle-Stack-Processor',
            'DataAggregation-Stack_DataAggregationLambda',
            'SystemManagementAPI-Stack-LambdaProxy',
            'consumer-data-Stack-typeHierarchy',
            'consumer-data-Stack-getObjectHistory',
            'consumer-data-Stack-link',
            'consumer-data-Stack-save',
            'consumer-data-Stack-query',
            'consumer-data-Stack-serializedGraphQuery',
            'consumer-data-Stack-getOne',
            'consumer-data-Stack-graphQuery',
        ],
    },
    SQS: {
        QueueName: [
            'networkDataIngestion',
            'deadLetters',
            'entityState',
            'DeviceTransactionQueue.fifo',
            'DeviceControlQueue.fifo',
            'subscriber-notification-queue',
            'sqmQueue',
            'notification-emit-queue',
            'deadLetters.fifo',
            'DatalifecycleQueue',
            'SystemAlerts-Network-AWOLQueue',
        ],
    },
};
export const databaseDimensionMap = {
    DynamoDB: {
        TableName: [dynamoDB.tableName],
        GlobalSecondaryIndexName: [dynamoDB.dynamicKeyGSIName, dynamoDB.gsiName, dynamoDB.tsiName, dynamoDB.typesiName],
        Operation: ['Query', 'DeleteItem', 'PutItem', 'BatchWriteItem', 'Scan', 'GetItem', 'BatchGetItem'],
    },
    Timestream: {
        DatabaseName: {
            Network: ['Device', 'Gateway'],
            Event: ['Events'],
        },
        Operation: ['WriteRecords', 'Query'],
    },
};
export const dimensionMap = { ...instanceDimensionsMap, ...databaseDimensionMap };
export const getDimensionKeyValue = (resourceDimensions, dimensionMap) => {
    for (const dimensionKey in dimensionMap) {
        const dimensionValue = dimensionMap[dimensionKey];
        if (Array.isArray(dimensionValue)) {
            resourceDimensions.push({ dimensionName: dimensionKey, dimensionValue });
        }
        else if (typeof dimensionValue === 'object') {
            resourceDimensions.push({ dimensionName: dimensionKey, dimensionValue: Object.keys(dimensionValue) });
            getDimensionKeyValue(resourceDimensions, dimensionValue);
        }
    }
};
export const getResourceDimension = (resourceName) => {
    let resourceDimensions = [];
    const resourceDimensionMap = dimensionMap[resourceName];
    getDimensionKeyValue(resourceDimensions, resourceDimensionMap);
    return resourceDimensions;
};
